import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const NotFound = (props: TSvgAssetProps) => (
  <SvgAsset width="288" height="275" viewBox="0 0 288 275" fill="none" {...props}>
    <path
      d="M51.4433 231.87C42.8969 228.05 37.3706 223.746 35.2473 219.257C33.124 214.767 34.4545 210.2 39.1466 205.872C43.8387 201.544 51.7802 197.558 62.4207 194.191C73.0612 190.823 86.1462 188.155 100.769 186.37"
      stroke="#99AED1"
      strokeWidth="6.09624"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M31.0242 191.167C48.1015 184.476 71.9256 179.463 99.251 176.812" stroke="#99AED1" strokeWidth="6.09624" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M258.215 238.514C275.468 231.535 284.568 223.157 284.201 214.59C283.834 206.023 274.019 197.712 256.174 190.857"
      stroke="#99AED1"
      strokeWidth="6.09624"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2802 239.863C16.3074 233.57 6.17561 225.973 4.16012 218.025C2.14464 210.078 8.33549 202.137 21.9535 195.201"
      stroke="#99AED1"
      strokeWidth="6.09624"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M171.562 243.68L164.101 213.997L98.4638 180.905C80.8938 195.677 64.1095 205.642 63.5169 216.095L171.562 243.68Z" fill="#6685BA" />
    <path d="M163.498 214.152L117.513 31.2107C111.829 31.9191 109.091 31.8356 105.09 30.4692L95.9204 204.089C112.458 221.057 128.936 221.05 163.498 214.152Z" fill="#335DA3" />
    <path
      d="M170.042 237.622L173.24 250.343L168.578 251.243C164.357 252.058 160.017 252.028 155.808 251.152L73.8412 234.11C73.8412 234.11 66.1119 231.545 64.2847 224.275C63.4189 220.831 63.5167 216.096 63.5167 216.096L170.042 237.622Z"
      fill="#335DA3"
    />
    <path d="M115.686 23.942L117.514 31.2112C112.081 31.8341 109.289 31.9163 105.091 30.4697C106.641 26.6127 109.265 25.343 115.686 23.942Z" fill="#00348D" />
    <path d="M135.481 102.688L126.345 66.3421C117.424 67.9681 111.952 68.1168 102.94 67.073L100.952 102.846C112.935 105.833 120.821 105.875 135.481 102.688Z" fill="#ECF1FB" />
    <path d="M153.753 175.38L144.617 139.034C124.342 142.843 114.179 143.051 99.32 138.183L97.3967 174.089C115.382 180.656 128.429 179.845 153.753 175.38Z" fill="#ECF1FB" />
    <path d="M169.759 244.175L162.298 214.493L204.486 154.297C226.953 159.005 246.454 159.849 251.919 168.78L169.759 244.175Z" fill="#00225D" />
    <path
      d="M162.883 214.267L116.898 31.3261C122.242 29.2627 124.615 27.8941 127.494 24.7984L217.67 173.446C211.121 196.217 196.599 204.003 162.883 214.267Z"
      fill="#00348D"
    />
    <path
      d="M168.215 238.045L171.413 250.766L175.946 249.355C180.051 248.078 183.861 245.998 187.156 243.237L251.322 189.462C251.322 189.462 256.919 183.546 255.092 176.277C254.226 172.833 251.901 168.707 251.901 168.707L168.215 238.045Z"
      fill="#00348D"
    />
    <path d="M115.089 24.1286L116.916 31.3977C121.997 29.3779 124.496 28.1299 127.512 24.8701C124.322 22.2046 121.409 22.3268 115.089 24.1286Z" fill="#00225D" />
    <path d="M134.884 102.88L125.748 66.5338C134.377 63.7486 138.89 61.3873 146.338 56.2061L165.01 86.9346C155.864 95.2327 149.309 98.7557 134.884 102.88Z" fill="#6685BA" />
    <path d="M153.156 175.571L144.02 139.226C163.686 132.995 172.74 128.373 183.531 117.057L202.203 147.786C189.461 162.077 177.582 167.532 153.156 175.571Z" fill="#6685BA" />
    <g style={{ mixBlendMode: 'hard-light' }} opacity="0.8" clipPath="url(#clip0_1680_15491)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M148.999 124.36L149.508 126.376L133.132 130.508L132.105 126.438C132.69 125.419 133.477 124.473 134.542 123.931C135.683 123.32 137.058 123.337 138.271 123.704C140.68 124.421 143.159 125.083 145.693 125.05C146.83 125.055 147.946 124.77 148.999 124.36ZM129.899 117.696L129 114.132L145.376 110L146.85 115.841C144.562 117.058 141.851 116.572 139.438 116.044C138.843 115.93 138.255 115.754 137.666 115.579C136.47 115.221 135.272 114.863 134.01 115.021C132.304 115.203 130.872 116.339 129.899 117.696ZM134.588 118.845C135.965 118.544 137.287 118.941 138.603 119.335C139.164 119.503 139.724 119.671 140.287 119.785C142.737 120.332 145.454 120.799 147.808 119.645L147.105 116.86C144.113 118.097 140.809 117.4 137.802 116.601C137.577 116.54 137.35 116.473 137.123 116.405C136.051 116.088 134.955 115.763 133.835 116.013C132.21 116.281 130.979 117.543 130.21 118.929L130.846 121.447C131.761 120.199 133.026 119.117 134.587 118.842L134.588 118.845ZM134.384 122.973C135.653 122.349 137.153 122.402 138.487 122.792C140.508 123.384 142.56 123.955 144.673 124.093C146.062 124.181 147.496 124.031 148.757 123.401L148.046 120.585C146.897 121.097 145.639 121.322 144.384 121.3C141.951 121.259 139.584 120.621 137.267 119.932C136.157 119.598 134.931 119.59 133.855 120.057C132.653 120.549 131.791 121.591 131.161 122.693L131.8 125.224C132.47 124.286 133.321 123.45 134.385 122.974L134.384 122.973Z"
        fill="white"
      />
    </g>
    <path d="M53.4011 214.633C129.653 227.826 153.707 234.586 228.667 211.937L256.17 255.618H53.4011V214.633Z" fill="#CCD6E8" />
    <path
      d="M62.4208 194.19C51.7803 197.558 43.8388 201.544 39.1467 205.872C34.4546 210.2 33.1241 214.767 35.2474 219.257C37.3707 223.746 42.897 228.05 51.4434 231.87C63.2661 235.898 70.6056 237.314 84.6793 238.9"
      stroke="#99AED1"
      strokeWidth="6.09624"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M241.609 202.229C248.62 203.847 253.936 207.876 253.727 215.337C253.518 222.797 243.939 229.99 226.723 235.615"
      stroke="#99AED1"
      strokeWidth="6.09624"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M44.8524 243.646C59.023 247.728 76.0666 250.888 94.8346 252.912" stroke="#99AED1" strokeWidth="6.09624" strokeLinecap="round" strokeLinejoin="round" />
    <defs>
      <clipPath id="clip0_1680_15491">
        <rect width="16.8889" height="16.8889" fill="white" transform="translate(129 114.132) rotate(-14.1609)" />
      </clipPath>
    </defs>
  </SvgAsset>
);

export default NotFound;
